import { useContext, useEffect } from "react";
import { Context } from "../context/Context";
import Layout from "../layouts/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "./SettingsPage.css";
import Profile from "../components/Profile";
import PaymentAmountModal from "../components/modals/PaymentAmountModal";

const ProfilePage = () => {
  const { page, setPage } = useContext(Context);

  useEffect(() => {
    setPage({
      name: "پروفایل",
      slug: "profile",
    });
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
            <div className="card h-100" style={{ backgroundColor: "#fff0", boxShadow: "none" }}>
              <div className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2">
                <h5>پروفایل کاربر</h5>
              </div>
              <div className="card-body scrollbar">
                <div>
                  <Profile />
                </div>
              </div>
            </div>
          </div>
          {/*/ Layout Demo */}
        </div>
      <PaymentAmountModal />
    </HelmetProvider>
  );
};

export default ProfilePage;
